import {
  SetBundleBusinessModelInput,
  SetBundleBusinessModelMutation,
  useSetBundleBusinessModelMutation,
} from 'generated/graphql';
import { FetchResult } from '@apollo/client';

export type MigrateToBundleModel = {
  migrate: (
    input: SetBundleBusinessModelInput,
  ) => Promise<FetchResult<SetBundleBusinessModelMutation>>;
};

export const useMigrateToBundleModel = (): MigrateToBundleModel => {
  const [setBundleBusinessMode] = useSetBundleBusinessModelMutation();

  const migrate = (input: SetBundleBusinessModelInput) =>
    setBundleBusinessMode({
      variables: {
        data: input,
      },
    });

  return {
    migrate,
  };
};
